import { detailProject } from "actions/project/detailProject";
import { apiService } from "constants/axiosInstance";
import {
  CustomEventDispose,
  CustomEventListener,
  DETAIL_PROJECT,
} from "constants/events";
import { get } from "lodash";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import ProjectTableDenyAndEmpty from "views/ProjectGroupPage/RightPart/ProjectTableDeny";
import { statusSelector } from "views/ProjectGroupPage/Modals/ProjectSetting/selectors.js";
import {
  bgColorSelector,
  memberTaskSelector,
  projectSelector,
  showHidePendingsSelector,
} from "views/ProjectPage/RightPart/AllTaskTable/selectors.js";
import {
  localOptionSelector,
  viewPermissionsSelector,
} from "views/ProjectPage/selectors.js";
import { apiCallRequest } from "views/SettingGroupPage/TablePart/SettingGroupRight/Home/redux/apiCall/actions";
import DashboardPresenters from "./presenters";
import LoadingBox from "components/LoadingBox";

function Dashboard({
  expand,
  handleExpand,
  viewPermissions,
  bgColor,
  isShortGroup,
  showHidePendings,
  handleSubSlide,
  tasks,
  project,
  doDetailProject,
  doDetailStatus,
  localOption,
  memberTask,
  status,
}) {
  const { timeType } = localOption;
  const { projectId, memberId } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const checkDeny = async () => {
    if (projectId !== null) {
      try {
        const res = await apiService({
          url: "/project/detail",
          method: "get",
          params: {
            project_id: projectId,
          },
        });
        if (res?.data?.state) {
          doDetailProject({ projectId });
          doDetailStatus({ projectId });
          setLoading(false);
        } else {
          history.push("/projects/deny");
        }
      } catch (e) {
        history.push("/projects/deny");
      }
    }
  };

  React.useEffect(() => {
    // checkDeny();
  }, [projectId]);

  return (
    <>
      {loading ? (
        <LoadingBox />
      ) : (
        <DashboardPresenters
          expand={expand}
          handleExpand={handleExpand}
          handleSubSlide={handleSubSlide}
          status={status.status || {}}
          canUpdateProject={get(
            viewPermissions.permissions,
            [projectId, "update_project"],
            false
          )}
          canCreateTask={true}
          isShortGroup={isShortGroup}
          showHidePendings={showHidePendings}
          tasks={tasks}
          project={project}
          memberID={memberId}
          memberTask={memberTask}
          bgColor={bgColor}
          timeType={timeType}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    status: statusSelector(state),
    project: projectSelector(state),
    bgColor: bgColorSelector(state),
    showHidePendings: showHidePendingsSelector(state),
    viewPermissions: viewPermissionsSelector(state),
    localOption: localOptionSelector(state),
    memberTask: memberTaskSelector(state),
    isShortGroup: state.groupTask.sortGroupTask.sortgroup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doDetailProject: ({ projectId }, quite) => {
      return dispatch(detailProject({ projectId }, quite));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
